const initialState =
{
	webinarData        : {},
	webinarSocket      : null,
	webinarLogo        : [],
	selectedLogo       : null,
	webinarBackground  : [],
	selectedBackground : null,
	webinarVideoClip   : null,
	webinarAudioClip   : null,
	webinarOverlays    : null,
	moveToVc           : false,
	surveyDataStore    : {},
	overlayImages      : [
		{ id           : '1',
			img          : '/webinar/ovrly1.svg',
			heading      : '',
			description  : '',
			mobileNumber : '',
			email        : '' },
		{ id           : '2',
			img          : '/webinar/ovrly2.svg',
			heading      : '',
			description  : '',
			mobileNumber : '',
			email        : '' },
		{ id           : '3',
			img          : '/webinar/ovrly3.svg',
			heading      : '',
			description  : '',
			mobileNumber : '',
			email        : '' }

	],
	showHide    : false,
	productCode : ''
};

const webinar = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'SET_WEBINAR_DATA':
		{
			const { webinarData } = action.payload;

			return { ...state, webinarData };
		}

		case 'SET_WEBINAR_SOCKET':
		{
			const { webinarSocket } = action.payload;

			return { ...state, webinarSocket };
		}

		case 'SET_WEBINAR_LOGO':
		{
			const { webinarLogo } = action.payload;

			return { ...state, webinarLogo };
		}

		case 'SET_SELECTED_WEBINAR_LOGO':
		{
			const { selectedLogo } = action.payload;

			return { ...state, selectedLogo };
		}

		case 'SET_WEBINAR_BACKGROUND':
		{
			const { webinarBackground } = action.payload;

			return { ...state, webinarBackground };
		}

		case 'SET_SELECTED_WEBINAR_BACKGROUND':
		{
			const { selectedBackground } = action.payload;

			return { ...state, selectedBackground };
		}
		case 'SET_WEBINAR_OVERLAY_IMAGES':
		{
			const { overlayImages } = action.payload;

			return { ...state, overlayImages };
		}
		case 'SET_SELECTED_WEBINAR_SHOW_HIDE_OVERLAY':
		{
			const toggle = !state?.showHide;

			return { ...state, showHide: toggle };
		}

		case 'SET_SELECTED_WEBINAR_VIDEO':
		{
			const { webinarVideoClip } = action.payload;

			return { ...state, 	webinarVideoClip };
		}

		case 'SET_SELECTED_WEBINAR_AUDIO':
		{
			const { webinarAudioClip } = action.payload;

			return { ...state, webinarAudioClip };
		}

		case 'SET_PRODUCT_CODE':
		{
			const { productCode } = action.payload;

			return { ...state, productCode };
		}

		case 'SET_SELECTED_WEBINAR_OVERLAYS':
		{
			const { webinarOverlays } = action.payload;

			return { ...state, webinarOverlays };
		}

		case 'SET_WEBINAR_USER_TO_VC':
		{
			const { moveToVc } = action.payload;

			return { ...state, moveToVc };
		}

		case 'SET_SURVEY_DATA':
		{
			const { surveyDataStore } = action.payload;

			return { ...state, surveyDataStore };
		}
		default:
			return state;
	}
};

export default webinar;
